import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface GradoState {
    status: string;
    error: string;
    gradoList: any[],
    gradoListActive: any[],
    grado: {
        idGrado: number | null;
        nombre: string | null;
    }

}

const initialState: GradoState = {
    status: 'idle',
    error: '',
    gradoList: [],
    gradoListActive: [],
    grado: {
        idGrado: null,
        nombre: null
    }
}

export const fetchGrado = createAsyncThunk('fetchGrado', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 43;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchGradoActive = createAsyncThunk('fetchGradoActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 44;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const gradoSlice = createSlice({
    name: 'grado',
    initialState,
    reducers: {
        setGradoList: (state, action) => {
            state.gradoList = action.payload;
        },
        setGradoListActive: (state, action) => {
            state.gradoListActive = action.payload;
        },
        setGrado: (state, action) => {
            state.grado = !action.payload ? initialState.grado : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGrado.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGrado.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.gradoList = data ? data : [];

            })
            .addCase(fetchGrado.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchGradoActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGradoActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.gradoListActive = data ? data : [];

            })
            .addCase(fetchGradoActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectGradoList = (state: RootState) => state.grado.gradoList;
export const selectGradoListActive = (state: RootState) => state.grado.gradoListActive;
export const selectGrado = (state: RootState) => state.grado.grado;

export const { setGradoList, setGradoListActive, setGrado } = gradoSlice.actions;

export default gradoSlice.reducer;



